export default __webpack_public_path__ + "static/media/orders.52bb93a0.svg";